<template>
  <div id="datacenter">
    <div class="body_top">
      <div class="body_dddyg">
        <div class="body_gddz">
          <div class="body_img">
            <img src="../../assets/ywcdd.png" alt="">
          </div>
          <div class="body_text">
            <p>{{ sybtinfo.finishOrderCount }}</p>
            <p>已完成订单数</p>
          </div>
        </div>
      </div>
      <div class="body_dddyg">
        <div class="body_gddz body_gddztwo">
          <div class="body_img">
            <img src="../../assets/jrdd.png" alt="">
          </div>
          <div class="body_text">
            <p>{{ sybtinfo.todayOrderCount }}</p>
            <p>今日订单数</p>
          </div>
        </div>
      </div>
      <div class="body_dddyg">
        <div class="body_gddz body_gddzthree">
          <div class="body_img">
            <img src="../../assets/jrdcldd.png" alt="">
          </div>
          <div class="body_text" style="cursor: pointer;" @click="wclddtzgdgglb">
            <p>{{ sybtinfo.waitDelOrderCount }}</p>
            <p>待处理订单</p>
          </div>
        </div>
      </div>
      <div class="body_dddyg">
        <div class="body_gddz body_gddzfore">
          <div class="body_img">
            <img src="../../assets/jrfkl.png" alt="">
          </div>
          <div class="body_text">
            <p>{{ sybtinfo.visitCount }}</p>
            <p>今日访客量</p>
          </div>
        </div>
      </div>
    </div>
    <div class="body_center">
      <div class="echarts_left">
        <div class="zzdecharts_top">
          <div class="uniys">
          <span></span>
          <span>下单数据趋势</span>
        </div>
        <div class="unimonth">
          <span
            v-for="(item, index) in spanlist"
            :key="index"
            :class="{ active: activeIndex == item.value }"
            @click="toggleClass(item.value)"
          >
            {{ item.name }}
          </span>
        </div>
        </div>
        <div id="oneleftChart"></div>
      </div>
      <div class="echarts_right">
        <div class="zzdecharts_top">
          <div class="uniys">
            <span></span>
            <span>公告</span>
          </div>
          <div class="unimonth" @click="tzgdgglb">
            <span>更多>></span>
          </div>
        </div>
        <div class="Notice_body">
          <div class="notextList" v-if="Noticelist.length <= 0">
            <img src="../../assets/zanwuhsj.png" alt="">
          </div>
            <p v-for="(item, index) in Noticelist"
            :key="index"
            :style="{ backgroundColor: isOdd(index) ? '#F3F3F3' : '' }"
            >
              <span>{{ item.subContent }}</span>
              <span>{{ item.endDate }}</span>
            </p>
        </div>
      </div>
    </div>
    <div class="body_bottom">
      <div class="uniys">
          <span></span>
          <span>产品种类销售数据</span>
        </div>
        <div id="twobottomChart"></div>
    </div>
  </div>
</template>

<script>
import hasDirective from '../../api/has'
import * as echarts from "echarts";
  export default {
    name:'datacenter',
    directives: {
        has: hasDirective
      },
    data(){
      return{
        spanlist: [
          { name: "近三天", value: "0" },
          { name: "近一个月", value: "1" },
          { name: "近三个月", value: "2" }], 
        activeIndex: 0,
        sybtinfo:{},
        Noticelist:[]
      }
    },
    created(){
      this.getlist()
      this.trendlist()
      this.salelist()
    },
    mounted(){
      
    },
    methods:{
      getlist() {
          this.$api.hqsyxxindex()
          .then((res) => {
                if (res.data.code == 200) {
                  let data = res.data.data
                  this.Noticelist =data.subjectIndexVos
                  if (data.waitDelOrderCount ==null) {
                    data.waitDelOrderCount = 0
                  }
                  this.sybtinfo =data 
               } else {
               this.$message.error(res.data.message)
               }
          })
       },
       trendlist() {
          this.$api.placeorder({
            queryStatus:this.activeIndex
          })
          .then((res) => {
                if (res.data.code == 200) {
                  let dateTime = []
                  let orderCount = []
                  let data = res.data.data
                for (let i = 0; i < data.length; i++) {
                    if(data[i].dateTime) {
                      dateTime.push(data[i].dateTime)
                    }  else {
                      dateTime.push(0)
                    }
                    if(data[i].orderCount) {
                      orderCount.push(data[i].orderCount)
                    }  else {
                      orderCount.push(0)
                    }
                }
                this.oneChart(dateTime,orderCount)
               } else {
               this.$message.error(res.data.message)
               }
          })
       },
       salelist() {
          this.$api.xssjsaleCate()
          .then((res) => {
                if (res.data.code == 200) {
                  let nameTime = []
                  let soldCount = []
                  let data = res.data.data
                for (let i = 0; i < data.length; i++) {
                    if(data[i].cateName) {
                      nameTime.push(data[i].cateName)
                    }
                }
                data.forEach(element => {
                    let data = {
                      value:element.saleCount,
                      cateId:element.cateId,
                      cateType:element.cateType
                    }
                    soldCount.push(data)
                });
                this.twoChart(nameTime,soldCount)
               } else {
               this.$message.error(res.data.message)
               }
          })
       },
      toggleClass(index) {
        this.activeIndex = index
        this.trendlist()
      },
      isOdd(number) {
          return number % 2 == 0;
        },
      oneChart(dateTime,orderCount) {
        this.Chart = echarts.init(document.getElementById("oneleftChart"));
        var option = {
            tooltip: {
              trigger: 'axis',
              backgroundColor: 'rgba(0,0,0,0.1)',
            },
            grid: {
              top: '5%',
              left: '5%',
              right: '2%',
              bottom: '8%',
              // containLabel: true
            },
            xAxis: [{
              type: 'category',
              color: '#59588D',
              axisLine: {
                show: true
              },
              axisLabel: {
                color: '#282828'
              },
              splitLine: {
                // show: true
              },

              axisTick: {
                show: false
              },
              // boundaryGap: true,
              data: dateTime

            }],
            yAxis: [{
              type: 'value',
              min: 2,
              splitNumber: 4,
              splitLine: {
                show: true,
              },
              axisLine: {
                show: true,
              },
              axisLabel: {
                show: true,
                // margin: 20,
                textStyle: {
                  color: '#737373',
                },
              },
              axisTick: {
                show: false,
              },
              splitLine: {
                lineStyle: {
                  color: 'rgba(131,101,101,0.2)',
                  type: 'dashed',
                }
              }
            }],
            series: [{
              name: '',
              type: 'line',
              smooth: true, //是否平滑
              showAllSymbol: true,
              symbol: 'circle',
              symbolSize: 10,
              lineStyle: {
                normal: {
                  color: "#48B3FF"
                },
              },
              label: {
                show: false,
                position: 'top',
                textStyle: {
                  color: '#48B3FF',
                }
              },

              itemStyle: {
                color: "#FFF",
                borderColor: "#48B3FF",
                borderWidth: 2,
                
              },
              tooltip: {
                show: true
              },
              areaStyle: {
                normal: {
                  color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                      offset: 0,
                      color: 'rgba(195,230,255,1)'
                    },
                    {
                      offset: 1,
                      color: 'rgba(195,230,255,0.1)'
                    }
                  ], false),
                  shadowColor: 'rgba(195,230,255,0.1)',
                  shadowBlur: 20
                }
              },
              data: orderCount,
            }]
          };
        this.Chart.setOption(option,true);
        // if (this.depthdeep != 3 && this.qxdeep !=3 && this.userType !=-1){
        //     this.Chart.on('click',(params) => {
        //       let dateTime = ''
        //       let treeCode = ''
        //       let seriesName = ''
        //       dateTime = params.name
        //       seriesName = params.seriesName
        //       treeCode = params.data.treeCode
        //       this.dialogVisible = true
        //       this.detailzxtxq(dateTime,treeCode,seriesName)
        //   });
        // }
      },
      twoChart(nameTime,soldCount) {
        this.Chart = echarts.init(document.getElementById("twobottomChart"));
        var colorArr = [
            {
                top: '#0889FD',//蓝色
                bottom: '#6AB4FF'
            }
        ];
        var option = {
            grid: {
                top: '10%',
                right: '2%',
                left: '2%',
                bottom: '8%'
            },
            xAxis: [{
                type: 'category',
                color: '#59588D',
                data: nameTime,
                axisLabel: {
                    margin: 20,
                    color: '#000',
                    textStyle: {
                        // fontSize: 16
                    },
                },
                axisLine: {
                    lineStyle: {
                        color: 'rgba(107,107,107,0.37)',
                    }
                },
                axisTick: {
                    show: false
                },
            }],
            yAxis: [{
                axisLabel: {
                    color: '#000',
                    textStyle: {
                        // fontSize: 16
                    },
                },
                axisLine: {
                    lineStyle: {
                        color: 'rgba(107,107,107,0.37)',
                    }
                },
                axisTick: {
                    show: false
                },
                splitLine: {
                    lineStyle: {
                        color: 'rgba(131,101,101,0.2)',
                        type: 'dashed',
                    }
                }
            }],
            series: [{
                type: 'bar',
                data: soldCount,
                barWidth: '30px',
                itemStyle: {
                    normal: {
                        color: function(params) {
                            let num = colorArr.length;
                            return new echarts.graphic.LinearGradient(0, 0, 0, 1,[{
                                offset: 0,
                                color: colorArr[params.dataIndex % num].top // 0% 处的颜色
                            },{//可根据具体情况决定哪根柱子显示哪种颜色
                                offset: 1,
                                color: colorArr[params.dataIndex % num].bottom // 100% 处的颜色
                            }],false)
                        },
                        barBorderRadius: [30, 30, 0, 0],
                    }
                },
                label: {
                    normal: {
                        show: true,
                        fontSize: 16,
                        fontWeight: 'bold',
                        color: '#999',
                        position: 'top',
                    }
                }
            }]
        };
        this.Chart.setOption(option,true);
        this.Chart.on('click',(params) => {
          if (params.data.cateType == 0) {
            this.$router.push({
                path: "productlist",
                query: {
                    cateId: params.data.cateId,
                  },
            });
          }else{
            this.$router.push({
                path: "accessories",
                query: {
                    cateId: params.data.cateId,
                  },
            });
          }
        });
        // if (this.depthdeep != 3 && this.qxdeep !=3 && this.userType !=-1){
        //     this.Chart.on('click',(params) => {
        //       let dateTime = ''
        //       let treeCode = ''
        //       let seriesName = ''
        //       dateTime = params.name
        //       seriesName = params.seriesName
        //       treeCode = params.data.treeCode
        //       this.dialogVisible = true
        //       this.detailzxtxq(dateTime,treeCode,seriesName)
        //   });
        // }
      },
      tzgdgglb() {
         this.$router.push({
            path: "noticegl",
         });
      },
      wclddtzgdgglb() {
         this.$router.push({
            path: "cpproductorder",
             query: {
                status: '0',
              },
         });
      },
    }
 }
</script>

<style scoped>
#datacenter {
  width: 100%;
  height: 100%;
  overflow-y: auto;
  background-color: #fff;
  padding:0 0 0 30px;
  box-sizing: border-box;
}
.body_top{
  display: flex;
  /* justify-content: center; */
  width: 100%;
}
.body_dddyg{
  width: 23%;
  margin-right: 60px;
}
.body_gddz{
  display: flex;
  width: 100%;
  height: 120px;
  border-radius: 10px;
  background: #EFF7FF;
  align-items: center;
  box-sizing: border-box;
}
.body_img{
  width: 45%;
  text-align: center;
}
.body_text{
  width:43%;
  text-align: center;
}
.body_text p{
  color: #333;
  font-family: Inter;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 42px;
  margin: 0;
}
.body_text p:nth-child(1){
  color: #0889FD;
  font-size: 26px;
  font-weight: 700;
}
.body_gddztwo .body_text p:nth-child(1){
  color: #FD7932;
  font-size: 26px;
  font-weight: 700;
}
.body_gddzthree .body_text p:nth-child(1){
  color: #FF444F;
  font-size: 26px;
  font-weight: 700;
}
.body_gddzfore .body_text p:nth-child(1){
  color: #0FCBD9;
  font-size: 26px;
  font-weight: 700;
}
.body_gddztwo{
  background: #FFF2EB;
}
.body_gddzthree{
  background: #FFF4F3;
}
.body_gddzfore{
  background: #EFFAFF;
}
.body_center{
  display: flex;
  margin-top: 40px;
}
.echarts_left{
  width: 50%;
}
.zzdecharts_top{
  display: flex;
  align-items: center;
  justify-content: space-between
}
.uniys{
  display: flex;
  align-items: center; /* 垂直居中 */
  color: #333;
  font-family: Inter;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
.uniys span:nth-child(1){
  display: inline-block;
  width: 4px;
  height: 30px;
  flex-shrink: 0;
  border-radius: 0px 10px 10px 0px;
  background: #0889FD;
  margin-right: 20px;
}
.unimonth{
  color: #666;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.unimonth span{
  display: inline-block;
  width: 86px;
  height: 36px;
  flex-shrink: 0;
  border-radius: 59px;
  background: #F1F3F4;
  line-height: 36px;
  text-align: center;
  margin-left: 24px;
  cursor: pointer;
}
.echarts_right{
  margin-left: 50px;
  width: 45%;
  margin-left: 50px;
}
.echarts_right .unimonth span{
  background: #fff;
}
/* 激活状态的样式 */
.active {
  background-color: #409eff !important;
  color: #fff;
}
#oneleftChart{
  width: 96%;
  height:450px;
  background-color: #fff; 
  padding: 20px;

}
#twobottomChart{
  width: 96%;
  height:450px;
  background-color: #fff; 
  padding: 20px;

}
.Notice_body{
  margin-top: 28px;
}
.Notice_body p{
  width: 98%;
  height: 48px;
  flex-shrink: 0;
  color: #000;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 48px;
  display: flex;
  justify-content: space-between;
  padding: 0 20px;
  margin: 10px 0;
  box-sizing: border-box;
}
.Notice_body p span:nth-child(1){
  display: inline-block;
  width: 74%;
  white-space: nowrap; /* 文本不换行 */
  overflow: hidden; /* 超出部分隐藏 */
  text-overflow: ellipsis; /* 使用省略号 */
}
.Notice_body p span:nth-child(2){
  color: #999;
}
.notextList {
  text-align: center;
  margin-top: 15px;
  font-size: 18px !important;
  padding-bottom: 10px;
  color: #aaa;
}
.notextList img{
  width: 370px;
  height: 200px;
}
</style>



// WEBPACK FOOTER //
// src/components/datacenter/datacenter.vue